import CompanyManagement from "../../Company Management/CompanyManagement";

const AnalystCompanyManagement = ({ TabConfig }) => {
  return <CompanyManagement TabConfig={TabConfig} isAnalyst={true} />;
};

export default AnalystCompanyManagement;
